var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "172px",
    height: "162px",
    viewBox: "0 0 172 162",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "browser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "40.206117%",
    x2: "50%",
    y2: "90.9025931%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.146789,23.4082569 L157.513761,23.4082569 C159.170616,23.4082569 160.513761,24.7514026 160.513761,26.4082569 L160.513761,38.2431193 C160.513761,39.8999735 159.170616,41.2431193 157.513761,41.2431193 L14.146789,41.2431193 C12.4899347,41.2431193 11.146789,39.8999735 11.146789,38.2431193 L11.146789,26.4082569 C11.146789,24.7514026 12.4899347,23.4082569 14.146789,23.4082569 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.7%",
    y: "-53.3%",
    width: "115.4%",
    height: "229.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.719986663   0 0 0 0 0.769382327   0 0 0 0 0.807801178  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 11.146789,
    y: 44.9587156,
    width: 98.4633028,
    height: 95.8623853,
    rx: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.7%",
    y: "-9.9%",
    width: "123.4%",
    height: "124.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.719986663   0 0 0 0 0.769382327   0 0 0 0 0.807801178  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.596494932%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.596494932%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.068807,66.1376147 L157.513761,66.1376147 C159.170616,66.1376147 160.513761,67.4807604 160.513761,69.1376147 L160.513761,137.821101 C160.513761,139.477955 159.170616,140.821101 157.513761,140.821101 L117.068807,140.821101 C115.411953,140.821101 114.068807,139.477955 114.068807,137.821101 L114.068807,69.1376147 C114.068807,67.4807604 115.411953,66.1376147 117.068807,66.1376147 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-24.8%",
    y: "-12.7%",
    width: "149.5%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.719986663   0 0 0 0 0.769382327   0 0 0 0 0.807801178  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.068807,44.9587156 L157.513761,44.9587156 C159.170616,44.9587156 160.513761,46.3018613 160.513761,47.9587156 L160.513761,59.0504587 C160.513761,60.707313 159.170616,62.0504587 157.513761,62.0504587 L117.068807,62.0504587 C115.411953,62.0504587 114.068807,60.707313 114.068807,59.0504587 L114.068807,47.9587156 C114.068807,46.3018613 115.411953,44.9587156 117.068807,44.9587156 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-24.8%",
    y: "-55.6%",
    width: "149.5%",
    height: "234.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.719986663   0 0 0 0 0.769382327   0 0 0 0 0.807801178  0 0 0 0.43 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sample",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-org-device-empty",
    transform: "translate(-720.000000, -400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(293.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(0.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-screen",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "browser",
    transform: "translate(427.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,13.3761468 L165.66055,13.3761468 C168.974259,13.3761468 171.66055,16.0624383 171.66055,19.3761468 L171.66055,156 C171.66055,159.313708 168.974259,162 165.66055,162 L6,162 C2.6862915,162 1.65932163e-14,159.313708 0,156 L0,19.3761468 C-4.05812251e-16,16.0624383 2.6862915,13.3761468 6,13.3761468 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    x: 17.8348624,
    y: 52.3899083,
    width: 70.0655308,
    height: 3.18479685,
    rx: 1.59239843
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    x: 17.8348624,
    y: 58.706422,
    width: 70.0655308,
    height: 3.18479685,
    rx: 1.59239843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8348624,66.1376147 L83.9003932,66.1376147 C86.1095322,66.1376147 87.9003932,67.9284757 87.9003932,70.1376147 L87.9003932,97.8073394 C87.9003932,100.016478 86.1095322,101.807339 83.9003932,101.807339 L21.8348624,101.807339 C19.6257234,101.807339 17.8348624,100.016478 17.8348624,97.8073394 L17.8348624,70.1376147 C17.8348624,67.9284757 19.6257234,66.1376147 21.8348624,66.1376147 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FAFCFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FAFCFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    x: 32.6972477,
    y: 30.8394495,
    width: 70.0655308,
    height: 3.18479685,
    rx: 1.59239843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3739128,28.6100917 L24.8051054,28.6100917 C25.9096749,28.6100917 26.8051054,29.5055222 26.8051054,30.6100917 L26.8051054,34.0412844 C26.8051054,35.1458539 25.9096749,36.0412844 24.8051054,36.0412844 L21.3739128,36.0412844 C20.2693433,36.0412844 19.3739128,35.1458539 19.3739128,34.0412844 L19.3739128,30.6100917 C19.3739128,29.5055222 20.2693433,28.6100917 21.3739128,28.6100917 Z",
    id: "Rectangle",
    fill: "#EFF3F9",
    transform: "translate(23.089509, 32.325688) rotate(-315.000000) translate(-23.089509, -32.325688) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIllustration);
export default __webpack_public_path__ + "static/media/no-data-illustration.0d854cd4016f5b0746686a40da108b74.svg";
export { ForwardRef as ReactComponent };